package com.essntl.features.invoice.domain.model

data class InvoiceModel(
    val id: String,
    val createdAt: String,
    val updatedAt: String?,
    val updatedBy: String?,
    val paymentLinkIds: List<String>?,
    val proposalServiceIds: List<String>?,
    val itineraryServiceIds: List<String>?,
    val extraServiceIds: List<String>?,
    val qbId: String?,
    val dueDate: String?,
    val proposalId: String?,
    val itineraryId: String?,
) {
    companion object {
        val empty = InvoiceModel(
            id = "",
            createdAt = "",
            updatedAt = "",
            updatedBy = null,
            proposalId = null,
            itineraryId = null,
            paymentLinkIds = emptyList(),
            proposalServiceIds = emptyList(),
            itineraryServiceIds = emptyList(),
            extraServiceIds = emptyList(),
            qbId = "",
            dueDate = "",
        )
    }
}